/**
 * Country flag SVG components — accurate proportions.
 * Cabo Verde (2:3) and São Tomé e Príncipe (1:2).
 * Sized via className width/height. Preserves official geometry.
 */

import React from "react";

/* ─────────── CABO VERDE 🇨🇻 ─────────── */
export const FlagCaboVerde = ({ className = "w-6 h-4", title = "Cabo Verde" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600"
    className={className}
    role="img"
    aria-label={title}
    data-testid="flag-cabo-verde"
  >
    <title>{title}</title>
    {/* Blue field */}
    <rect width="900" height="600" fill="#003893" />
    {/* White stripe */}
    <rect y="300" width="900" height="200" fill="#0A0F1A" />
    {/* Red stripe (middle of white band) */}
    <rect y="366.66" width="900" height="66.66" fill="#CF2027" />
    {/* Circle of 10 yellow stars centred at (225, 400) with radius 150 */}
    {Array.from({ length: 10 }).map((_, i) => {
      const angle = (i / 10) * 2 * Math.PI - Math.PI / 2;
      const cx = 225 + 150 * Math.cos(angle);
      const cy = 400 + 150 * Math.sin(angle);
      return <Star key={i} cx={cx} cy={cy} r={18} fill="#F7D116" />;
    })}
  </svg>
);

/* ─────────── SÃO TOMÉ E PRÍNCIPE 🇸🇹 ─────────── */
export const FlagSaoTome = ({ className = "w-6 h-4", title = "São Tomé e Príncipe" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000 500"
    className={className}
    role="img"
    aria-label={title}
    data-testid="flag-sao-tome"
  >
    <title>{title}</title>
    {/* Green top */}
    <rect width="1000" height="500" fill="#12AD2B" />
    {/* Yellow middle stripe (double width) */}
    <rect y="125" width="1000" height="250" fill="#FFCE00" />
    {/* Green bottom band drawn separately for clarity */}
    <rect y="375" width="1000" height="125" fill="#12AD2B" />
    {/* Red triangle on hoist */}
    <polygon points="0,0 350,250 0,500" fill="#D21034" />
    {/* Two black 5-pointed stars centred in yellow band */}
    <Star cx={625} cy={250} r={38} fill="#000000" />
    <Star cx={860} cy={250} r={38} fill="#000000" />
  </svg>
);

/* ─────────── GENERIC 5-POINTED STAR ─────────── */
function Star({ cx, cy, r, fill }) {
  const points = [];
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    const rad = i % 2 === 0 ? r : r / 2.5;
    points.push(`${cx + rad * Math.cos(angle)},${cy + rad * Math.sin(angle)}`);
  }
  return <polygon points={points.join(" ")} fill={fill} />;
}

/* ─────────── LOOKUP BY SLUG ─────────── */
export const CountryFlag = ({ slug, className = "w-6 h-4" }) => {
  if (slug === "cabo-verde") return <FlagCaboVerde className={className} />;
  if (slug === "sao-tome")   return <FlagSaoTome className={className} />;
  if (slug === "mionga")     return (
    <div className={`${className} flex items-center justify-center rounded-md`}
      style={{ background: "#FBFAF6", border: "1px solid rgba(212,168,87,0.4)" }}>
      <img src="/mionga/logo-icon-transparent.png" alt="MIONGA"
        className="w-full h-full object-contain p-0.5" />
    </div>
  );
  return null;
};
